import React from "react";
import "./FleetCoreVerifiedDriverOnboarding.css";

import fleetcoreVerifiedDriverOnboardingDriverPhotoJpg from "../../images/fleetcore-driver-selfie-next-to-bakkie.jpg";
import fleetcoreVerifiedDriverOnboardingDriverPhotoWebp from "../../images/fleetcore-driver-selfie-next-to-bakkie.webp";
import fleetcoreVerifiedDriverOnboardingEvidenceInterface from "../../images/fleetcore-verified-driver-onboarding-evidence-interface.svg";

export default function FleetCoreVerifiedDriverOnboarding() {
  return (
    <section className="fleetcore-verified-driver-onboarding" id="fleetcore-drivers" aria-labelledby="fleetcore-verified-driver-onboarding-title">
      <div className="fleetcore-verified-driver-onboarding__inner">
        <div className="fleetcore-verified-driver-onboarding__visual">
          <picture><source srcSet={fleetcoreVerifiedDriverOnboardingDriverPhotoWebp} type="image/webp" /><img className="fleetcore-verified-driver-onboarding__photo" src={fleetcoreVerifiedDriverOnboardingDriverPhotoJpg} alt="Fleet driver capturing licence evidence on a smartphone before operating a commercial vehicle" /></picture>
          <img className="fleetcore-verified-driver-onboarding__interface" src={fleetcoreVerifiedDriverOnboardingEvidenceInterface} alt="FleetCore driver evidence profile showing identity, licence and work-permit evidence ready for human review" />
        </div>
        <div className="fleetcore-verified-driver-onboarding__copy">
          <p className="fleetcore-verified-driver-onboarding__eyebrow">KNOW WHO IS OPERATING</p>
          <h2 id="fleetcore-verified-driver-onboarding-title">Accountability begins with the driver.</h2>
          <p className="fleetcore-verified-driver-onboarding__body">FleetCore captures driver identity and required operating credentials before the first shift. Submitted licences and work permits are structured into one reviewable driver profile, supported by facial matching.</p>
          <ul className="fleetcore-verified-driver-onboarding__evidence">
            <li>Identity evidence captured</li>
            <li>Licence details structured</li>
            <li>Work-permit requirement recorded</li>
          </ul>
          <p className="fleetcore-verified-driver-onboarding__principle">Evidence captured. Facial match supported. Human reviewed.</p>
        </div>
      </div>
    </section>
  );
}
